module.exports = __webpack_public_path__ + "images/Minus.ddcb6430b79177f07af5589984481284.svg";